import { PropsWithChildren, useEffect, useState } from 'react';
import useUrlTokenLogin from './hooks/useUrlTokenLogin';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from './store';
import {
  toggleRTL,
  toggleTheme,
  toggleLocale,
  toggleMenu,
  toggleLayout,
  toggleAnimation,
  toggleNavbar,
  toggleSemidark,
} from './store/themeConfigSlice';
import store from './store';
import { getUser } from './lib/busniessFunctions';
import { useNavigate } from 'react-router-dom';
import Loader from './components/Loader';
import LoginCoverNumber from './pages/Authentication/LoginCoverNumber';
// import { use } from 'i18next';

function App({ children }: PropsWithChildren) {
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const dispatch = useDispatch();

  // handle token in URL and call getUser if present
  useUrlTokenLogin();

  useEffect(() => {
    const hydrateThemeActions: Array<[string, (value: any) => any]> = [
      ['theme', toggleTheme],
      ['menu', toggleMenu],
      ['layout', toggleLayout],
      ['rtlClass', toggleRTL],
      ['animation', toggleAnimation],
      ['navbar', toggleNavbar],
      ['i18nextLng', toggleLocale],
      ['semidark', toggleSemidark],
    ];

    hydrateThemeActions.forEach(([key, action]) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        dispatch(action(value));
      }
    });
  }, [dispatch]);

  const { user } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (user) {
        setShowLoader(false);
        return;
      }

      if (!localStorage.getItem('token')) {
        navigate('/auth/login');
        setShowLoader(false);
        return;
      }

      try {
        const fetchedUser = await getUser(dispatch);
        if (!fetchedUser) {
          navigate('/auth/login');
          return;
        }
        if (fetchedUser.user_uid) {
          localStorage.setItem('uid', fetchedUser.user_uid);
        }
      } catch (error) {
        navigate('/auth/login');
        toast.error('Something went wrong!');
      } finally {
        setShowLoader(false);
      }
    };

    checkLoginStatus();
  }, [dispatch, navigate, user]);

  if (showLoader) {
    return <Loader />;
  }
  if (!user && !showLoader) {
    <LoginCoverNumber />;
  }

  return (
    <div
      className={`${(store.getState().themeConfig.sidebar && 'toggle-sidebar') || ''} ${themeConfig.menu} ${themeConfig.layout} ${
        themeConfig.rtlClass
      } main-section antialiased relative font-nunito text-sm font-normal`}
    >
      <Toaster position="top-center" reverseOrder={false} />

      {children}
    </div>
  );
}

export default App;
